/* eslint-disable react-hooks/exhaustive-deps */
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useEffect, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux"
import { TWijmoCellTemplateContext } from "../../../../type/wijmoComponents"

import { RootState } from "../../../../globalStore/rootreducer"
import { TBsyoIdoRirekiData } from "../../../../globalStore/pageStore/zyomuinMaster/busyoIdoRireki"
import CONSTANT from "../../../../constant"

/**
 * 部所異動履歴Accordion
 */
const BsyoIdoRirekiPane = () => {
  //#region [selector]
  const zyomuinMaster = useSelector(
    (state: RootState) => state.page.zyomuinMaster
  )

  //#endregion

  //#region [method]

  // 部所異動履歴CollectionView
  const createCollectionViewBsyoIdoRireki = (data: TBsyoIdoRirekiData[]) =>
    new wjcCore.CollectionView(data)
  // 部所異動履歴_初期化
  const initGridBsyoIdoRireki = (grid: wjcGrid.FlexGrid) => {
    setFlexGridBsyoIdoRireki(grid)
  }

  //#endregion

  // #region [state]
  // 部所異動履歴
  const [itemsSourceBsyoIdoRireki, setItemsSourceBsyoIdoRireki] = useState<
    wjcCore.CollectionView<TBsyoIdoRirekiData>
  >(
    createCollectionViewBsyoIdoRireki([
      ...zyomuinMaster.部所異動履歴データリスト,
    ])
  )
  const [flexGridBsyoIdoRireki, setFlexGridBsyoIdoRireki] =
    useState<wjcGrid.FlexGrid>()

  //#endregion

  //#region [effect]
  useEffect(() => {
    setItemsSourceBsyoIdoRireki(
      createCollectionViewBsyoIdoRireki([
        ...zyomuinMaster.部所異動履歴データリスト,
      ])
    )

    flexGridBsyoIdoRireki?.refresh()
  }, [zyomuinMaster.部所異動履歴データリスト])
  //#endregion

  return (
    <>
      <div className="accordion-header">
        部所異動履歴
        <div className="accordion-description">部所異動履歴</div>
      </div>
      <div>
        <Row>
          <Col>
            <h5>部所異動履歴</h5>
            <Container fluid>
              <Row>
                <Col>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                    initialized={initGridBsyoIdoRireki}
                    itemsSource={itemsSourceBsyoIdoRireki}>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      binding="所属開始日"
                      width={CONSTANT.GRID.COL_SIZE.COL_CALENDAR_SIZE}
                      header="異動日">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TBsyoIdoRirekiData>
                        ) => {
                          return (
                            <>
                              {wjcCore.Globalize.format(
                                new Date(context.item.所属開始日),
                                "d"
                              )}
                            </>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                    {/* <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      width={150}
                      binding="会社コード"
                      header="会社"></wjrGrid.FlexGridColumn> */}
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      width={150}
                      binding="会社名"
                      header="会社名"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      width={80}
                      binding="部所コード"
                      header="部所"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      width={200}
                      binding="部所名"
                      header="部所名"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      cssClass="read-only-cell"
                      width={200}
                      binding="備考"
                      header="備考"></wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default BsyoIdoRirekiPane
